import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Lock, Star, Zap } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
const CHECKOUT_URL = 'https://vidassinlimites.com/cart/47016729903282:1';
export function FinalCTA() {
  const handleCheckout = () => {
    // Track AddToCart event before redirecting
    trackAddToCart();
    // Small delay to ensure tracking fires before redirect
    setTimeout(() => {
      window.location.href = CHECKOUT_URL;
    }, 300);
  };
  return <section id="offer" className="py-16 px-4 bg-[#0f0f16] relative overflow-hidden" data-id="element-21">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-[300px] bg-[#ff2d7a]/5 blur-[80px] rounded-full pointer-events-none" data-id="element-22" />

      <div className="max-w-md mx-auto relative z-10" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#1a1a24] rounded-2xl p-6 sm:p-8 border border-[#ff2d7a]/30 shadow-[0_0_40px_rgba(255,45,122,0.1)]" data-id="element-24">
          <div className="flex items-center justify-center gap-2 mb-6" data-id="element-25">
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#ff2d7a]/10 text-[#ff2d7a] text-xs font-bold" data-id="element-26">
              <Star size={12} fill="currentColor" data-id="element-27" />
              Oferta de Lanzamiento
            </div>
            <div className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-green-500/10 text-green-400 text-xs font-bold" data-id="element-28">
              <Zap size={10} fill="currentColor" data-id="element-29" />
              68% OFF
            </div>
          </div>

          <div className="text-center mb-6" data-id="element-30">
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-31">
              <span className="text-2xl text-gray-500 line-through" data-id="element-32">
                $19.99
              </span>
              <span className="text-5xl font-bold text-white" data-id="element-33">$6.39</span>
            </div>
            <p className="text-gray-400 text-sm" data-id="element-34">
              Menos que una cena.{' '}
              <span className="text-[#ff2d7a]" data-id="element-35">
                Más duradero que un regalo.
              </span>
            </p>
          </div>

          <div className="space-y-3" data-id="element-36">
            <Button size="lg" fullWidth className="text-base h-14" onClick={handleCheckout} data-id="element-37">
              Obtener el Protocolo
            </Button>

            <div className="flex items-center justify-center gap-2 text-xs text-gray-500" data-id="element-38">
              <Lock size={12} data-id="element-39" />
              <span data-id="element-40">Pago seguro & encriptado</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}